import RecaptchaFix from "../../utils/RecaptchaFix";
import BaseDeviseController from "./BaseDeviseController";

export default class ConfirmationNew extends BaseDeviseController {

    constructor() {
        super();
        this.recaptchaFix = new RecaptchaFix('#new_customer');
        this.initValidation();
        this.bindEvents();
        this.toggleSubmit();
    }


    bindEvents() {
        $(`#${this.resource_name}_email`).off( 'keyup', this.toggleSubmit ).on('keyup', () => this.toggleSubmit() )
        $('#btn-confirmation').click(() => { document.getElementById('new_customer').reportValidity()})
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.recaptchaFix.onDestroy();
    }

    toggleSubmit() {
        let email = $(`#${this.resource_name}_email`).val().trim();
        if( email !== '' ) {
            $('#btn-confirmation').removeClass('disabled')
        } else {
            $('#btn-confirmation').addClass('disabled')
        }
    }

    initValidation() {
        application.setTemplateValidation({
            [`${this.resource_name}[email]`]: {
                required: true,
                email_validation: true
            },
        }, '#new_customer')
    }
}